// extracted by mini-css-extract-plugin
export default {"form":"ChangePasswordForm_form__Z+2XX","submit":"ChangePasswordForm_submit__PIsTS"};